module.exports = __webpack_public_path__ + "img/goods8_2.b3229318.jpg";